type DateValue = string | number | Date | null | undefined;

const validDate = (value: DateValue): Date | null => {
  if (value == null || value === '') return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDateDDMMYY = (value: DateValue, fallback = '--', timeZone?: string): string => {
  const date = validDate(value);
  if (!date) return fallback;
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    ...(timeZone ? { timeZone } : {}),
  }).format(date);
};

export const formatDateTimeDDMMYY = (value: DateValue, fallback = '--', timeZone?: string): string => {
  const date = validDate(value);
  if (!date) return fallback;
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    ...(timeZone ? { timeZone } : {}),
  }).format(date).replace(',', '');
};

export const formatTime24 = (value: DateValue, fallback = '--', timeZone?: string): string => {
  const date = validDate(value);
  if (!date) return fallback;
  return new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    ...(timeZone ? { timeZone } : {}),
  }).format(date);
};
